export function getErrorTypeText(errorType: string) {
  switch (errorType) {
    case "required":
      return "required";
    case "pattern":
    default:
      return "not valid";
  }
}
